import { render, staticRenderFns } from "./ProductPage4.vue?vue&type=template&id=2debc5aa"
import script from "./ProductPage4.vue?vue&type=script&lang=js"
export * from "./ProductPage4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports